import { createContext, useEffect, useReducer } from "react";
import axios from "axios";
// CUSTOM COMPONENT
import { MatxLoading } from "app/components";
import { getRequest, postRequest } from "app/utils/request";
import { useDataContext } from "./DataContext";
import { useRouter } from "app/hooks/useRouter";

const initialState = {
  user: null,
  isInitialized: false,
  isAuthenticated: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialized: true, user };
    }

    case "LOGIN": {
      return { ...state, isAuthenticated: true, user: action.payload.user };
    }

    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }

    case "REGISTER": {
      const { user } = action.payload;

      return { ...state, isAuthenticated: true, user };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  login: () => {},
  logout: () => {},
  register: () => {}
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const router = useRouter();

  const login = async (email, password) => {
    const response = await postRequest("/auth/login", { userName: email, password }, router);

    const { accessToken, refreshToken } = response.data;

    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      localStorage?.setItem("refreshToken", refreshToken);
    }

    dispatch({ type: "LOGIN", payload: { user: response.data } });
  };

  const register = async (email, username, password) => {
    const response = await axios.post("/api/auth/register", { email, username, password });
    const { user } = response.data;

    dispatch({ type: "REGISTER", payload: { user } });
  };

  const logout = () => {
    dispatch({ type: "LOGOUT" });
    localStorage.clear();
  };

  useEffect(() => {
    (async () => {
      try {
        if (localStorage?.getItem("accessToken")) {
          const { data } = await getRequest("/auth/my-profile", router);
          dispatch({ type: "INIT", payload: { isAuthenticated: true, user: data } });
        } else {
          dispatch({ type: "INIT", payload: { isAuthenticated: false, user: null } });
          localStorage.clear();
        }
      } catch (err) {
        console.error(err);
        dispatch({ type: "INIT", payload: { isAuthenticated: false, user: null } });
        // localStorage.removeItem("accessToken");
      }
    })();
  }, []);

  // SHOW LOADER
  if (!state.isInitialized) return <MatxLoading />;

  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
